// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar-header {
    width: 100%;
    background-color: #265d38;
    padding: 15px 0;
    box-shadow: none;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: visible;
    margin-bottom: 40px;
    z-index: 1000;
    top: 0;
}

.header-top {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

.branding {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
    width: 100%;
}

.brand-name {
    margin-top: 40px !important;
    color: #f2cd01;
    font-size: 2.2rem;
    font-weight: bold;
    margin: 0;
    padding: 0;
}

.brand-description {
    font-size: 1.2rem;
    color: #ffffff;
    margin-top: 5px;
    padding-left: 0;
    max-width: 100%;
}

.navigation-buttons {
    margin-top: -20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
}
.primary-nav,
.secondary-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: flex-start;
}

.nav-button {
    color: #000000;
    background-color: #ffffff;
    padding: 8px 15px;
    text-decoration: none;
    border-radius: 4px;
    font-weight: bold;
    transition: background-color 0.3s ease;
    flex: 0 1 auto;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
    align-items: center;
}

.nav-button:hover {
    background-color: #f0f0f0;
}

.nav-button.primary {
    background-color: #f2cd01;
}

.nav-button.primary:hover {
    background-color: #e0bd00;
}

.search-bar-container {
    margin-top: 10px;
    width: 100%;
    max-width: 960px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    z-index: 1001;
    box-sizing: border-box;
}

.search-bar-wrapper {
    position: relative;
    width: 100%;
    border: 2px solid #fff;
    border-radius: 8px;
    background-color: #333;
    transition: border-color 0.3s ease;
    display: flex;
    align-items: center;
    padding: 8px;
    box-sizing: border-box;
    margin-bottom: 5px;
    z-index: 1002;
}

.search-text {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1rem;
    color: #fff;
    transition: all 0.3s ease;
    pointer-events: none;
    z-index: 1003;
}

.search-bar {
    flex-grow: 1;
    padding: 10px;
    font-size: 1.2rem;
    border: none;
    background-color: transparent;
    color: #fff;
    outline: none;
    margin-left: 5px;
    transition: margin-left 0.3s ease;
    width: 100%;
}

.search-bar-wrapper:focus-within {
    border-color: #f2cd01;
}

.search-bar-wrapper:focus-within .search-text,
.search-bar:not(:placeholder-shown) + .search-text {
    top: 0;
    transform: translateY(-50%) translateX(10px);
    font-size: 0.8rem;
    background-color: #333;
    padding: 0 5px;
    color: #f2cd01;
}

.search-bar:focus::placeholder {
    color: transparent;
}

.search-bar-underlay {
    font-size: 0.9rem;
    color: #cecece;
    margin-top: 5px;
    padding-left: 0;
    max-width: 100%;
    margin-bottom: 40px;
}

@media (max-width: 1000px) {
    .header-top {
        padding: 0 10px;
    }

    .search-bar-container {
        max-width: calc(100% - 20px);
        margin-left: 10px;
        margin-right: 10px;
    }

    .search-bar-wrapper {
        max-width: 100%;
    }

    .search-bar {
        margin-left: 0;
        padding: 8px 10px;
        font-size: 1rem;
    }

    .search-results {
        left: 0;
        right: 0;
        width: 100%;
    }
}

.loading-bar-container {
    width: 100%;
    height: 4px;
    background-color: #2a2a2a;
    position: relative;
    overflow: hidden;
}

.loading-bar {
    width: 30%;
    height: 100%;
    background-color: #f2cd01;
    position: absolute;
    left: -25%;
    animation: loading 1.5s ease-in-out infinite;
}

@keyframes loading {
    0% {
        left: -30%;
    }
    50% {
        left: 130%;
    }
    100% {
        left: -30%;
    }
}

.loading-screen {
    display: none;
}

.search-results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #464646;
    border-radius: 0 0 8px 8px;
    padding: 0 15px 15px;
    max-height: 400px;
    overflow-y: auto;
    z-index: 1004;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: none;
    box-sizing: border-box;
}

.result-list {
    margin-top: 10px;
    color: #ddd;
}

.section-heading {
    color: #ddd !important;
    margin-bottom: 10px;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    gap: 5px;
}

.clickable-result {
    padding: 10px;
    margin: 5px 0;
    background-color: #2a2a2a;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.clickable-result:hover {
    background-color: #3a3a3a;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.search-active .overlay {
    opacity: 1;
    pointer-events: auto;
}

.search-active .search-bar-wrapper {
    border-radius: 4px 4px 0 0;
}

.search-active .search-results {
    display: block;
}

.courses-section h2,
.professors-section h2 {
    background-color: #2a2a2a;
    color: #fff !important;
    margin: 0 -15px 10px -15px;
    padding: 10px 15px;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    gap: 5px;
}

.search-results::-webkit-scrollbar {
    width: 10px;
}

.search-results::-webkit-scrollbar-track {
    background: #2a2a2a;
}

.search-results::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
}

.search-results::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.search-results {
    scrollbar-width: thin;
    scrollbar-color: #888 #2a2a2a;
}

/* New styles for primary navigation buttons */
.nav-button.primary {
    background-color: #f2cd01;
    color: #000000;
}

.nav-button.primary:hover {
    background-color: #e0bd00;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .navigation-buttons {
        flex-direction: column;
        align-items: stretch;
    }

    .nav-button {
        max-width: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/SearchBar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,MAAM;AACV;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;AACA;;IAEI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,MAAM;IACN,4CAA4C;IAC5C,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,OAAO;QACP,QAAQ;QACR,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,4CAA4C;AAChD;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA,8CAA8C;AAC9C;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".search-bar-header {\n    width: 100%;\n    background-color: #265d38;\n    padding: 15px 0;\n    box-shadow: none;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    overflow: visible;\n    margin-bottom: 40px;\n    z-index: 1000;\n    top: 0;\n}\n\n.header-top {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 0 20px;\n    box-sizing: border-box;\n}\n\n.branding {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.brand-name {\n    margin-top: 40px !important;\n    color: #f2cd01;\n    font-size: 2.2rem;\n    font-weight: bold;\n    margin: 0;\n    padding: 0;\n}\n\n.brand-description {\n    font-size: 1.2rem;\n    color: #ffffff;\n    margin-top: 5px;\n    padding-left: 0;\n    max-width: 100%;\n}\n\n.navigation-buttons {\n    margin-top: -20px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n}\n.primary-nav,\n.secondary-nav {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    justify-content: flex-start;\n}\n\n.nav-button {\n    color: #000000;\n    background-color: #ffffff;\n    padding: 8px 15px;\n    text-decoration: none;\n    border-radius: 4px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n    flex: 0 1 auto;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-flex;\n    align-items: center;\n}\n\n.nav-button:hover {\n    background-color: #f0f0f0;\n}\n\n.nav-button.primary {\n    background-color: #f2cd01;\n}\n\n.nav-button.primary:hover {\n    background-color: #e0bd00;\n}\n\n.search-bar-container {\n    margin-top: 10px;\n    width: 100%;\n    max-width: 960px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    position: relative;\n    z-index: 1001;\n    box-sizing: border-box;\n}\n\n.search-bar-wrapper {\n    position: relative;\n    width: 100%;\n    border: 2px solid #fff;\n    border-radius: 8px;\n    background-color: #333;\n    transition: border-color 0.3s ease;\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    box-sizing: border-box;\n    margin-bottom: 5px;\n    z-index: 1002;\n}\n\n.search-text {\n    position: absolute;\n    left: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 1rem;\n    color: #fff;\n    transition: all 0.3s ease;\n    pointer-events: none;\n    z-index: 1003;\n}\n\n.search-bar {\n    flex-grow: 1;\n    padding: 10px;\n    font-size: 1.2rem;\n    border: none;\n    background-color: transparent;\n    color: #fff;\n    outline: none;\n    margin-left: 5px;\n    transition: margin-left 0.3s ease;\n    width: 100%;\n}\n\n.search-bar-wrapper:focus-within {\n    border-color: #f2cd01;\n}\n\n.search-bar-wrapper:focus-within .search-text,\n.search-bar:not(:placeholder-shown) + .search-text {\n    top: 0;\n    transform: translateY(-50%) translateX(10px);\n    font-size: 0.8rem;\n    background-color: #333;\n    padding: 0 5px;\n    color: #f2cd01;\n}\n\n.search-bar:focus::placeholder {\n    color: transparent;\n}\n\n.search-bar-underlay {\n    font-size: 0.9rem;\n    color: #cecece;\n    margin-top: 5px;\n    padding-left: 0;\n    max-width: 100%;\n    margin-bottom: 40px;\n}\n\n@media (max-width: 1000px) {\n    .header-top {\n        padding: 0 10px;\n    }\n\n    .search-bar-container {\n        max-width: calc(100% - 20px);\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n\n    .search-bar-wrapper {\n        max-width: 100%;\n    }\n\n    .search-bar {\n        margin-left: 0;\n        padding: 8px 10px;\n        font-size: 1rem;\n    }\n\n    .search-results {\n        left: 0;\n        right: 0;\n        width: 100%;\n    }\n}\n\n.loading-bar-container {\n    width: 100%;\n    height: 4px;\n    background-color: #2a2a2a;\n    position: relative;\n    overflow: hidden;\n}\n\n.loading-bar {\n    width: 30%;\n    height: 100%;\n    background-color: #f2cd01;\n    position: absolute;\n    left: -25%;\n    animation: loading 1.5s ease-in-out infinite;\n}\n\n@keyframes loading {\n    0% {\n        left: -30%;\n    }\n    50% {\n        left: 130%;\n    }\n    100% {\n        left: -30%;\n    }\n}\n\n.loading-screen {\n    display: none;\n}\n\n.search-results {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background-color: #464646;\n    border-radius: 0 0 8px 8px;\n    padding: 0 15px 15px;\n    max-height: 400px;\n    overflow-y: auto;\n    z-index: 1004;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    display: none;\n    box-sizing: border-box;\n}\n\n.result-list {\n    margin-top: 10px;\n    color: #ddd;\n}\n\n.section-heading {\n    color: #ddd !important;\n    margin-bottom: 10px;\n    font-size: 1.2rem;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.clickable-result {\n    padding: 10px;\n    margin: 5px 0;\n    background-color: #2a2a2a;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.clickable-result:hover {\n    background-color: #3a3a3a;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    z-index: 999;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.3s ease;\n}\n\n.search-active .overlay {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.search-active .search-bar-wrapper {\n    border-radius: 4px 4px 0 0;\n}\n\n.search-active .search-results {\n    display: block;\n}\n\n.courses-section h2,\n.professors-section h2 {\n    background-color: #2a2a2a;\n    color: #fff !important;\n    margin: 0 -15px 10px -15px;\n    padding: 10px 15px;\n    font-size: 1.2rem;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.search-results::-webkit-scrollbar {\n    width: 10px;\n}\n\n.search-results::-webkit-scrollbar-track {\n    background: #2a2a2a;\n}\n\n.search-results::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 5px;\n}\n\n.search-results::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.search-results {\n    scrollbar-width: thin;\n    scrollbar-color: #888 #2a2a2a;\n}\n\n/* New styles for primary navigation buttons */\n.nav-button.primary {\n    background-color: #f2cd01;\n    color: #000000;\n}\n\n.nav-button.primary:hover {\n    background-color: #e0bd00;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .navigation-buttons {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .nav-button {\n        max-width: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
